import Loader from 'Common/Loader';
import DataGrid, { Column, Pager, Paging, Scrolling, SearchPanel, Summary, TotalItem } from 'devextreme-react/cjs/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import React, { useCallback, useMemo, useState } from 'react';
import { Card } from 'react-bootstrap';
import ShowModal from './ShowModel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, } from '@fortawesome/free-solid-svg-icons';
import { GetReturnSalesOrder, GetReturnSalesOrderItemById } from '../sevices/ReturnOrderService';



const RreturnOrderList: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [salesData, setSalesData] = useState<any[]>([]);
    const [refreshKey, setRefreshKey] = useState(0);


    // const dataSource = useMemo(() => {
    //     return new CustomStore({
    //         key: 'id',
    //         load: async (loadOptions) => {
    //             try {
    //                 const search = JSON.parse(JSON.stringify(loadOptions));
    //                 let parameterList = new URLSearchParams();
    //                 for (const [key, value] of Object.entries(search)) {
    //                     parameterList.append(key, JSON.stringify(value));
    //                 }
    //                 const response = await GetReturnSalesOrder(parameterList);
    //                 return response;
    //             } catch (error) {
    //                 console.error("Data loading error:", error);
    //                 return { data: [], totalCount: 0 };
    //             }
    //         },
    //     });
    // }, [refreshKey]);

    const dataSource = (): any | undefined => {
        return new CustomStore({
          key: "id",
          load: async (loadOptions) => {
            try {
              const { searchValue, skip, take } = loadOptions;
              const parameterList = new URLSearchParams();
    
              if (typeof skip === 'number') parameterList.append('skip', skip.toString());
              if (typeof take === 'number') parameterList.append('take', take.toString());
    
    
              const search = JSON.parse(JSON.stringify(loadOptions));
              for (const [key, value] of Object.entries(search)) {
                parameterList.append(key, JSON.stringify(value));
              }
    
              if (searchValue) {
                parameterList.append("search", searchValue);
              }
    
              const response = await GetReturnSalesOrder(parameterList);
             
               return response
            } catch (error) {
              console.error("Data loading error:", error);
              return { data: [], totalCount: 0 };
            }
          },
        });
      };


    const handleShowDetails = async (salesOrderId: string) => {
        try {
            const res = await GetReturnSalesOrderItemById(salesOrderId);
            setSalesData(res?.data || []);
            setShowModal(true);
        } catch (err) {
            console.error("Failed to fetch sales entry", err);
        }

    }


    // const renderSerialNumber = useCallback((cellData: any) => {
    //     const rowIndex = cellData.rowIndex + 1 + cellData.component.pageIndex() * cellData.component.pageSize();
    //     return <span>{rowIndex}</span>;
    // }, []);

    const renderActionButtons = useCallback((cellData: any) => (
        <div className='d-flex gap-1'>
            <button
                className='btn btn-sm'
                onClick={() => handleShowDetails(cellData.data.id)}
                title='View details'
            >
                <FontAwesomeIcon icon={faEye} title="View details" className="ml-2 " />
            </button>

        </div>
    ), []);

    const reloadDataSource = useCallback(() => {
        setRefreshKey((prev) => prev + 1);
    }, []);

   const formatDateToIST = (utcDateString: string): string => {
    if (!utcDateString) return "";
    // Ensure it's parsed as UTC
    const date = new Date(utcDateString + "Z");
    return new Intl.DateTimeFormat("en-IN", {
      timeZone: "Asia/Kolkata", // Force IST
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true, // 12h format with AM/PM
    })
      .format(date)
      .replace(",", ""); // remove comma for clean look
  };

    return (
        <React.Fragment>
            {loading && <Loader />}

            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <h5 className='m-0'>Return Order List</h5>
                        </Card.Header>
                        <Card.Body>
                            <DataGrid
                                dataSource={dataSource()}
                                remoteOperations={{ groupPaging: true }}
                                columnAutoWidth={true}
                                showRowLines={true}
                                keyExpr="id"
                                showBorders={true}
                                onContentReady={(e) => {
                                    const hasData = e.component.totalCount() > 0;
                                    e.component.option("pager.visible", hasData);
                                    e.component.option("paging.visible", hasData);
                                }}
                            >
                                <Scrolling
                                    mode='standard'
                                    useNative={true}
                                    scrollByContent={true}
                                    scrollByThumb={true}
                                />

                                <Pager
                                    showPageSizeSelector={true}
                                    allowedPageSizes={[10, 25, 50, 100]}
                                    showNavigationButtons={true}
                                    displayMode="full"
                                    showInfo={true}
                                />
                                <Summary>
                                    <TotalItem
                                    // column="Sr.No."
                                    // summaryType="count"
                                    // displayFormat="Total : {0}"
                                    />
                                </Summary>
                                <Paging defaultPageSize={10} />
                                <SearchPanel visible width={240} />

                                {/* <Column
                                    caption="Sr.No."
                                    dataType="number"
                                    alignment="center"
                                    cellRender={renderSerialNumber}
                                /> */}

                                <Column
                                    dataField='id'
                                    caption='Id'
                                    visible={false}
                                    sortOrder='desc'
                                    allowFiltering={false}
                                />
                                <Column
                                    // cssClass='text-center'
                                    allowFiltering={false}
                                    dataField="action"
                                    caption="Action"
                                    dataType="string"
                                    cellRender={renderActionButtons}
                                />
                                <Column
                                    cssClass='text-center'
                                    allowFiltering={true}
                                    dataField="returnCode" caption="Invoice No" dataType="string" />
                                <Column
                                    cssClass='text-center'
                                    allowFiltering={true}
                                    dataField="totalReturnSaleOrderAmount" caption="Return  Amount" dataType="number" format='#,##0.00' />
                                <Column
                                    cssClass='text-center'
                                    allowFiltering={true}
                                    dataField="returnSaleType" caption="Type" dataType="string" />
                                <Column
                                    cssClass='text-center'
                                    allowFiltering={true}
                                    dataField="paymentType" caption="Payment Type" dataType="string" />
                                <Column
                                    cssClass='text-center'
                                    allowFiltering={true}
                                    dataField="storeCode" caption="Store Code" dataType="string" />

                                <Column
                                    allowFiltering={false}
                                    dataField="createdOn"
                                    caption="Created On"
                                    dataType="string"
                                    width={200}
                                    calculateDisplayValue={(rowData) => formatDateToIST(rowData.createdOn)}
                                />


                            </DataGrid>
                        </Card.Body>
                    </Card>
                </div>
            </div>


            <ShowModal
                show={showModal}
                onClose={() => setShowModal(false)}
                data={salesData}
            />

        </React.Fragment>
    );
};

export default RreturnOrderList;